/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Px } from '../assets/posize';
import HeaderBlack from '../components/HeaderBlack';

export default function SOUL8(props) {
  return (
    <div
      style={{
        '--src': `url(${
          require('assets/40a8975aff9c933441ac77826a638af3.png').default
        })`
      }}
      className={`s-ou-l8 ${css(styles.group, styles.group_layout)}`}
    >
      <div className={css(styles.cover_group, styles.cover_group_layout)}>
        <div className={css(styles.flex, styles.flex_layout)}>
          <div className={css(styles.flex_item)}>
            <div className={css(styles.component, styles.component_layout)}>
              <HeaderBlack
                highlights={props.highlights}
                icon={props.icon}
                image={props.image}
              />
            </div>
          </div>
          <div className={css(styles.flex_item1)}>
            <div
              style={{
                '--src': `url(${
                  require('assets/f5539b08bd2aa7b9915cc94cb340b66d.png').default
                })`
              }}
              className={css(styles.cover_group1, styles.cover_group1_layout)}
            >
              <div
                style={{
                  '--src': `url(${
                    require('assets/757d526d85c07aa170971468dcd64209.png')
                      .default
                  })`
                }}
                className={css(styles.icon, styles.icon_layout)}
              />
            </div>
          </div>
          <h4 className={css(styles.highlights, styles.highlights_layout)}>
            {'你/妳的靈魂是'}
          </h4>
          <h1 className={css(styles.big_title, styles.big_title_layout)}>
            {'甜美如蜜的小不點'}
          </h1>
          <div className={css(styles.flex_item2)}>
            <h5 className={css(styles.highlights1, styles.highlights1_layout)}>
              {
                '從花朵裡出生的迷你小不點，是身邊人的寶貝。你的存在，是許下願望之後就會成真的代表，為人們帶來驚喜與期盼。善良的你有點嬌小、有點慵懶，總是在冒險的路上，吸引所有人的注意。'
              }
            </h5>
          </div>
          <div className={css(styles.flex_item3)}>
            <div
              onClick={() => window.open('/soul', '_self')}
              className={`${css(
                styles.cover_group2,
                styles.cover_group2_layout
              )} cursor-pointer to-more`}
            >
              {'五感靈魂樣貌'}
            </div>
          </div>
          <div className={css(styles.flex_item4)}>
            <div
              style={{
                '--src': `url(${
                  require('assets/cb99bf4081f9a538d19358d130521bba.png').default
                })`
              }}
              className={css(styles.image, styles.image_layout)}
            />
          </div>
          <h4 className={css(styles.highlights2, styles.highlights2_layout)}>
            {'專屬於你的風味想像'}
          </h4>
          <div className={css(styles.flex_item5)}>
            <div
              className={css(
                styles.paragraph_body,
                styles.paragraph_body_layout
              )}
            >
              {
                '為何花園中長出一株飽滿的麥穗？又為何麥穗上長出了花苞？花苞盛開花朵、美麗的小不點出現，看似稀鬆平常卻又千載難逢，這就是平凡的人也能擁有的喜悅與幸福。'
              }
            </div>
          </div>
          <div className={css(styles.flex_item6)}>
            <h4 className={css(styles.highlights3, styles.highlights3_layout)}>
              {'推薦給你：果花火釀的茶・冰釀蜜香有機紅烏龍'}
            </h4>
          </div>
          <div className={css(styles.flex_item7)}>
            <div
              className={css(
                styles.paragraph_body,
                styles.paragraph_body_layout1
              )}
            >
              {
                '將綻而未綻的花朵，比鮮花更多了些淘氣與俏皮，也多了對未來的想像。等待甜美、等待長大、等待奇蹟降臨時適合的一款茶。'
              }
            </div>
          </div>
          <div className={css(styles.flex_item8)}>
            <div className={css(styles.flex1, styles.flex1_layout)}>
              <div className={css(styles.flex1_item)}>
                <div
                  className={css(
                    styles.cover_group3,
                    styles.cover_group3_layout
                  )}
                >
                  {'風味標籤'}
                </div>
              </div>
              <div className={css(styles.flex1_spacer)} />
              <div
                className={css(
                  styles.small_text_body,
                  styles.small_text_body_layout
                )}
              >
                {'橙花蜂蜜、蜜桃、太妃糖、香草、雞蛋花、甜酒釀'}
              </div>
            </div>
          </div>
          <div className={css(styles.flex_item)}>
            <div className={css(styles.flex2, styles.flex2_layout)}>
              <div className={css(styles.flex2_item)}>
                <div
                  className={css(
                    styles.cover_group4,
                    styles.cover_group4_layout
                  )}
                >
                  <div
                    className={css(
                      styles.small_text_body1,
                      styles.small_text_body1_layout
                    )}
                  >
                    {'茶體'}
                  </div>
                </div>
              </div>
              <div className={css(styles.flex2_spacer)} />
              <div
                className={css(
                  styles.small_text_body,
                  styles.small_text_body_layout1
                )}
              >
                {'輕盈'}
              </div>
              <div className={css(styles.flex2_spacer1)} />
              <div className={css(styles.flex2_item1)}>
                <div className={css(styles.flex3, styles.flex3_layout)}>
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/3ab85d97e799db388a98c791288c7b75.svg')
                          .default
                      })`
                    }}
                    className={css(styles.image1, styles.image1_layout)}
                  />
                  <div className={css(styles.flex3_item)}>
                    <div className={css(styles.group1, styles.group1_layout)}>
                      <div
                        style={{
                          '--src': `url(${
                            require('assets/2b667d060944ab387d2db4da8bd6d3f4.svg')
                              .default
                          })`
                        }}
                        className={css(styles.image2, styles.image2_layout)}
                      />
                    </div>
                  </div>
                  <div className={css(styles.flex3_item)}>
                    <div className={css(styles.group2, styles.group2_layout)}>
                      <div
                        style={{
                          '--src': `url(${
                            require('assets/ca958939d092dcfe5eb2c7f6bbc115ab.svg')
                              .default
                          })`
                        }}
                        className={css(styles.image3, styles.image3_layout)}
                      />
                    </div>
                  </div>
                  <div className={css(styles.flex3_item)}>
                    <div className={css(styles.group3, styles.group3_layout)}>
                      <div
                        style={{
                          '--src': `url(${
                            require('assets/d4756b676771b5674c40f907fdacd015.svg')
                              .default
                          })`
                        }}
                        className={css(styles.image4, styles.image4_layout)}
                      />
                    </div>
                  </div>
                  <div className={css(styles.flex3_item3)}>
                    <div className={css(styles.group4, styles.group4_layout)}>
                      <div
                        style={{
                          '--src': `url(${
                            require('assets/8f1bc970190a9433cc6fc0c5fa0398c5.svg')
                              .default
                          })`
                        }}
                        className={css(styles.image5, styles.image5_layout)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={css(styles.flex_item10)}>
            <div className={css(styles.group5, styles.group5_layout)}>
              <div className={css(styles.flex4, styles.flex4_layout)}>
                <div className={css(styles.flex4_item)}>
                  <div
                    className={css(
                      styles.cover_group5,
                      styles.cover_group5_layout
                    )}
                  >
                    <div
                      className={css(
                        styles.small_text_body3,
                        styles.small_text_body3_layout
                      )}
                    >
                      {'泡法'}
                    </div>
                  </div>
                </div>
                <div className={css(styles.flex4_spacer)} />
                <div className={css(styles.flex4_item1)}>
                  <div className={css(styles.flex5, styles.flex5_layout)}>
                    <div className={css(styles.flex5_item)}>
                      <div className={css(styles.flex6, styles.flex6_layout)}>
                        <div className={css(styles.flex6_item)}>
                          <div
                            style={{
                              '--src': `url(${
                                require('assets/215e907768758e1ab50b8b2a3fa739c8.png')
                                  .default
                              })`
                            }}
                            className={css(styles.image6, styles.image6_layout)}
                          />
                        </div>
                        <div className={css(styles.flex6_spacer)} />
                        <div
                          className={css(
                            styles.small_text_body4_box,
                            styles.small_text_body4_box_layout
                          )}
                        >
                          <div className={css(styles.small_text_body4)}>
                            <span
                              className={css(styles.small_text_body4_span0)}
                            >
                              {'600ml'}
                            </span>
                            <span
                              className={css(styles.small_text_body4_span1)}
                            >
                              {' 冷萃'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body5_box,
                        styles.small_text_body5_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body5)}>
                        <span className={css(styles.small_text_body5_span0)}>
                          {'茶葉 '}
                        </span>
                        <span className={css(styles.small_text_body5_span1)}>
                          {'6g'}
                        </span>
                        <span className={css(styles.small_text_body5_span2)}>
                          {' / 茶包'}
                        </span>
                        <span className={css(styles.small_text_body5_span3)}>
                          {'2'}
                        </span>
                        <span className={css(styles.small_text_body5_span4)}>
                          {'個'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body,
                        styles.small_text_body_layout2
                      )}
                    >
                      {'水溫：常溫'}
                    </div>
                    <div
                      className={css(
                        styles.small_text_body7_box,
                        styles.small_text_body7_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body7)}>
                        <span className={css(styles.small_text_body7_span0)}>
                          {'時間：放冰箱'}
                        </span>
                        <span className={css(styles.small_text_body7_span1)}>
                          {'24'}
                        </span>
                        <span className={css(styles.small_text_body7_span2)}>
                          {'小時，搖勻後飲用'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={css(styles.flex_item11)}>
            <div
              onClick={() =>
                window.open(
                  'https://www.daughter-tea.com/product.aspx?openExternalBrowser=1&Id=10'
                )
              }
              className={`${css(
                styles.cover_group6,
                styles.cover_group6_layout
              )} cursor-pointer to-more`}
            >
              {'了解更多'}
            </div>
          </div>
          <div className={css(styles.flex_item12)}>
            <div
              onClick={() => window.open('/', '_self')}
              className={`${css(
                styles.cover_group7,
                styles.cover_group7_layout
              )} cursor-pointer to-home`}
            >
              <div
                className={css(styles.background, styles.background_layout)}
              />
              <h5
                className={css(styles.highlights4, styles.highlights4_layout)}
              >
                {'重新探索'}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SOUL8.inStorybook = true;

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    backgroundColor: 'rgb(255,255,255)'
  },
  group_layout: {
    position: 'relative',
    minHeight: 1595.04,
    flexGrow: 1
  },
  cover_group: {
    display: 'flex',
    backgroundColor: 'rgb(254,240,238)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group_layout: {
    position: 'relative',
    height: 'min-content',
    width: 375,
    minWidth: 375,
    margin: '0px auto'
  },
  flex: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '53px 13px'
  },
  flex_item: {
    display: 'flex',
    flex: '0 1 30px'
  },
  component: {},
  component_layout: {
    minHeight: 29,
    flexGrow: 1,
    margin: '1px 14px 0px 3px'
  },
  flex_item1: {
    display: 'flex',
    flex: '0 1 297px'
  },
  cover_group1: {
    display: 'flex',
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group1_layout: {
    position: 'relative',
    minHeight: 257,
    flexGrow: 1,
    margin: '40px 3px 0px'
  },
  icon: {
    background: 'var(--src) center center / contain no-repeat'
  },
  icon_layout: {
    height: 40,
    width: 39,
    minWidth: 39,
    margin: '87px 141px 130px auto'
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    font: '18px/1.79 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px',
    opacity: 0.69875
  },
  highlights_layout: {
    flex: '1 0 auto',
    margin: '15px 3px 0px'
  },
  big_title: {
    display: 'flex',
    alignItems: 'center',
    font: '500 30px/1.8 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  big_title_layout: {
    flex: '1 0 auto',
    margin: '8px 3px 0px'
  },
  flex_item2: {
    display: 'flex',
    flex: '0 1 134px'
  },
  highlights1: {
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights1_layout: {
    flexGrow: 1,
    margin: '22px 3px 0px'
  },
  flex_item3: {
    display: 'flex',
    flex: '0 1 54px'
  },
  cover_group2: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cover_group2_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '10px 3px 0px'
  },
  flex_item4: {
    display: 'flex',
    flex: '0 1 302px'
  },
  image: {
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  image_layout: {
    height: 257,
    flexGrow: 1,
    margin: '45px 0px 0px 5px'
  },
  highlights2: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights2_layout: {
    flex: '1 0 auto',
    margin: '21px 3px 0px'
  },
  flex_item5: {
    display: 'flex',
    flex: '0 1 95px'
  },
  paragraph_body: {
    font: '14px/1.57 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  paragraph_body_layout: {
    flexGrow: 1,
    margin: '7px 3px 0px'
  },
  flex_item6: {
    display: 'flex',
    flex: '0 1 95px'
  },
  highlights3: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights3_layout: {
    flexGrow: 1,
    margin: '39px 3px 0px'
  },
  flex_item7: {
    display: 'flex',
    flex: '0 1 81px'
  },
  paragraph_body_layout1: {
    flexGrow: 1,
    margin: '15px 3px 0px'
  },
  flex_item8: {
    display: 'flex',
    flex: '0 1 36px'
  },
  flex1: {
    display: 'flex'
  },
  flex1_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex1_item: {
    display: 'flex',
    flex: '0 1 62px'
  },
  cover_group3: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 5px 0px 5px'
  },
  cover_group3_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '16px 0px 0px 3px'
  },
  flex1_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  small_text_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body_layout: {
    flex: '1 1 auto',
    margin: '16px 0px 0px'
  },
  flex2: {
    display: 'flex'
  },
  flex2_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex2_item: {
    display: 'flex',
    flex: '0 1 62px'
  },
  cover_group4: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group4_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '10px 0px 0px 3px'
  },
  small_text_body1: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  small_text_body1_layout: {
    width: 25,
    minWidth: 25,
    margin: '0px auto'
  },
  flex2_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  small_text_body_layout1: {
    margin: '10px 0px 0px'
  },
  flex2_spacer1: {
    flex: '0 0 auto',
    minWidth: 9
  },
  flex2_item1: {
    display: 'flex',
    flex: '0 1 246px'
  },
  flex3: {
    display: 'flex'
  },
  flex3_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '12px 0px 0px'
  },
  image1: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image1_layout: {
    flex: '0 1 13px',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '2px 0px 4px'
  },
  flex3_item: {
    display: 'flex',
    flex: '0 1 14px'
  },
  group1: {
    display: 'flex',
    opacity: 0.2
  },
  group1_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image2: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image2_layout: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  group2: {
    display: 'flex',
    opacity: 0.2
  },
  group2_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image3: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image3_layout: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  group3: {
    display: 'flex',
    opacity: 0.2047374636627907
  },
  group3_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image4: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image4_layout: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  flex3_item3: {
    display: 'flex',
    flex: '0 1 191px'
  },
  group4: {
    display: 'flex',
    opacity: 0.2047374636627907
  },
  group4_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 177px 0px 0px'
  },
  image5: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image5_layout: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  flex_item10: {
    display: 'flex',
    flex: '0 1 90px'
  },
  group5: {
    display: 'flex'
  },
  group5_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex4: {
    display: 'flex'
  },
  flex4_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 3px'
  },
  flex4_item: {
    display: 'flex',
    flex: '0 1 59px'
  },
  cover_group5: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group5_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '6px 0px 69px'
  },
  small_text_body3: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '12px/1.2 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  small_text_body3_layout: {
    width: 25,
    minWidth: 25,
    margin: '1px auto'
  },
  flex4_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  flex4_item1: {
    display: 'flex',
    flex: '0 1 276px'
  },
  flex5: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex5_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '8px 18px 0px 0px'
  },
  flex5_item: {
    display: 'flex',
    flex: '0 1 22px'
  },
  flex6: {
    display: 'flex'
  },
  flex6_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex6_item: {
    display: 'flex',
    flex: '0 1 14px'
  },
  image6: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image6_layout: {
    height: 18,
    width: 9,
    minWidth: 9,
    margin: '0px 0px 4px auto'
  },
  flex6_spacer: {
    flex: '0 0 auto',
    minWidth: 9
  },
  small_text_body4: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body4_box: {},
  small_text_body4_box_layout: {
    flex: '1 1 auto',
    margin: '2px 0px 0px'
  },
  small_text_body4_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body4_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body5_box: {},
  small_text_body5_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body5_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body_layout2: {
    flex: '1 0 auto'
  },
  small_text_body7: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body7_box: {},
  small_text_body7_box_layout: {
    flex: '0 0 auto'
  },
  small_text_body7_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body7_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body7_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex_item11: {
    display: 'flex',
    flex: '0 1 56px'
  },
  cover_group6: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cover_group6_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '12px 3px 0px'
  },
  flex_item12: {
    display: 'flex',
    flex: '0 1 60px'
  },
  cover_group7: {
    display: 'flex'
  },
  cover_group7_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '16px 3px 0px'
  },
  background: {
    border: '1px solid rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  background_layout: {
    position: 'absolute',
    height: 44,
    flexGrow: 1,
    inset: '0px 0px auto'
  },
  highlights4: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(94,117,111)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights4_layout: {
    flexGrow: 1,
    margin: '8px 0px'
  }
});
